import template from './teamRequests.html';
import controller from './teamRequests.controller';
import './teamRequests.scss';

let teamRequestsComponent = {
  restrict: 'E',
  bindings: {
    isWageInProcess: '<'
  },
  template,
  controller
};

export default teamRequestsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.component.js